export default 'redux_state';
